import {
  ADD_ACCOUNT_TRANSACTION_CLIENT,
  ADD_ACCOUNT_TRANSACTION_CLIENT_SUCCESS,
  ADD_ACCOUNT_TRANSACTION_CLIENT_FAIL,
  DELETE_ACCOUNT_TRANSACTION_CLIENT,
  DELETE_ACCOUNT_TRANSACTION_CLIENT_SUCCESS,
  DELETE_ACCOUNT_TRANSACTION_CLIENT_FAIL,
  APPROVE_ACCOUNT_TRANSACTION_CLIENT,
  APPROVE_ACCOUNT_TRANSACTION_CLIENT_SUCCESS,
  APPROVE_ACCOUNT_TRANSACTION_CLIENT_FAIL,
  ADD_ACCOUNT_TRANSACTION_CLIENT_BANK,
  ADD_ACCOUNT_TRANSACTION_CLIENT_BANK_SUCCESS,
  ADD_ACCOUNT_TRANSACTION_CLIENT_BANK_FAIL,
  ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT,
  ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT_SUCCESS,
  ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT_FAIL
} from "./actionTypes";

export const addAccountTransactionClient = (data, history) => ({
  type: ADD_ACCOUNT_TRANSACTION_CLIENT,
  payload: { data, history },
});
export const addAccountTransactionClientSuccess = () => ({
  type: ADD_ACCOUNT_TRANSACTION_CLIENT_SUCCESS,
});
export const addAccountTransactionClientFail = error => ({
  type: ADD_ACCOUNT_TRANSACTION_CLIENT_FAIL,
  payload: error,
});

export const deleteAccountTransactionClient = (data, callback) => ({
  type: DELETE_ACCOUNT_TRANSACTION_CLIENT,
  payload: { data, callback },
});
export const deleteAccountTransactionClientSuccess = () => ({
  type: DELETE_ACCOUNT_TRANSACTION_CLIENT_SUCCESS,
});
export const deleteAccountTransactionClientFail = error => ({
  type: DELETE_ACCOUNT_TRANSACTION_CLIENT_FAIL,
  payload: error,
});

export const approveAccountTransactionClient = (data, callback) => ({
  type: APPROVE_ACCOUNT_TRANSACTION_CLIENT,
  payload: { data, callback },
});
export const approveAccountTransactionClientSuccess = () => ({
  type: APPROVE_ACCOUNT_TRANSACTION_CLIENT_SUCCESS,
});
export const approveAccountTransactionClientFail = error => ({
  type: APPROVE_ACCOUNT_TRANSACTION_CLIENT_FAIL,
  payload: error,
});

export const addAccountTransactionClientBank = (companyId, accountNumberId, tipeBank, uploadFile, history) => ({
  type: ADD_ACCOUNT_TRANSACTION_CLIENT_BANK,
  payload: { companyId, accountNumberId, tipeBank, uploadFile, history },
});
export const addAccountTransactionClientBankSuccess = () => ({
  type: ADD_ACCOUNT_TRANSACTION_CLIENT_BANK_SUCCESS,
});
export const addAccountTransactionClientBankFail = error => ({
  type: ADD_ACCOUNT_TRANSACTION_CLIENT_BANK_FAIL,
  payload: error,
});

export const addAccountTransactionClientByExcel = (uploadFile, companyId, history) => ({
  type: ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT,
  payload: { uploadFile, companyId, history },
});
export const addAccountTransactionClientByExcelSuccess = () => ({
  type: ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT_SUCCESS,
});
export const addAccountTransactionClientByExcelFail = error => ({
  type: ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT_FAIL,
  payload: error,
});